"use strict";

var keyMirror = require('keymirror'),
    _ = require('underscore'),
    MobileDetect = require('mobile-detect'),
    roles = keyMirror({
        USER: null,
        ADMIN: null,
        AGENT: null,
        DEVELOPER: null,
        BUILDER: null,
        BROKER: null
    }),
    URI = require('urijs'),
    md = new MobileDetect(window.navigator.userAgent),
    mobile = md.mobile();

var constants = {
    md: md,
    canClipboardCopy: mobile !== 'iPhone' && mobile !== 'iPad',
    root: '/',
    isToolbox: true,
    env: window._AS_ENV_,
    imageRoot: "production" === "development" ? '/public/resources/images/' : '/resources/images/',
    publicRoot: "production" === "development" ? '/public/' : '/',
    trackingPath: "production" === "development" ? '//devapi.agentshield.com/t/1x1clear.gif' : '//api.agentshield.com/t/1x1clear.gif',
    server: "production" === "development" ? '//dev.agentshield.com' : '//app.agentshield.com',
    restPath: "production" === "development" ? '//dev.toolbox.agentshield.com/agent-shield-1.0/rest' : '//api.agentshield.com/agent-shield-1.0/rest',
    widgetHost: '//widgets.agentshield.com',
    toolboxHost: "production" === "development" ? '//dev.toolbox.agentshield.com' : '//toolbox.agentshield.com',
    defaultRedirect: ['Dashboard'],
    roles: roles,
    jsonPSupport: true,
    placeholder: require('../images/placeholder.js'),
    trackerPrefix: 'agent-toolbox-',
    intercomAppId: "production" === "development" ? 'fglggop8' : 'fglggop8',
    intercomAppIdAgent: 'fglggop8',
    googleAnalyticsId: 'UA-462934-5',
    segmentId: 'PRVG6s9TWd0fg3eyIPrGuJ4xNbRhwQYS',
    safeAPIs: [],
    unsafeAPIs: [
        // AQUA at Pelican Isle, Naples 
        "b58d14f8-ecf4-418e-a7a4-746de0d4b002"
    ],
    signupAgentRedirect: 'Widgets',
    translateLocation: 'page',
    thumbRoot: '//s3.amazonaws.com/thumbs.agentshield.com/',
    publicSite: '//newconstructionhub.com',
    // intercomAppId: process.env.NODE_ENV === "development" ? 'fglggop8' : 'eovn4bxl',
    userTypes: [{
        id: 'Agent',
        name: 'Agent'
    }],
    search: URI.parseQuery(window.location.search),
    query: function() {
        return _.pick(constants.search, 'API', 'bAPI');
    }
};

switch (window._AS_ENV_) {
    case 'dev':
        _.extend(constants, require('./config_dev'));
        break;
    case 'prod':
        _.extend(constants, require('./config_prod'));
        break;
    case 'staging':
        _.extend(constants, require('./config_staging'));
        break;
}

module.exports = constants;
